import type { insights } from '@repletoryreach/sdk-api';
import type { Filters, Row } from '../lib/data';

/** What every tab of a report gets: the report, its chats after the filters, all its chats, and how to show some chats. */
export interface TabProps {
  report: insights.InsightReport;
  rows: Row[];
  all: Row[];
  filters: Filters;
  /** True when a filter narrows the chats: figures are then of the chats shown, with no change on the period before. */
  filtered: boolean;
  tz: string;
  onSee: (refs: string[]) => void;
}

export const TABS = ['overview', 'topics', 'chatbot', 'stopped', 'gaps', 'demand', 'improvements', 'chats', 'questions'] as const;
export type Tab = (typeof TABS)[number];
